import { useFetchTextResponses } from '@mentimeter/presentation-data-hooks/fetch-text-responses';
import type { TextResponse } from '@core-api/presentation/types/response';
import type { OpenVotesT } from '@mentimeter/question-modules-types';

interface OpenEndedResponse {
  id: string;
  responseText: string;
  voteCount: number;
  participantDisplayName: string | null;
}

interface UseTextResponsesParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
  shouldShowIdentifiedResponses?: boolean;
  legacyResponses: Array<OpenVotesT>;
}

export const useTextResponses = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
  shouldShowIdentifiedResponses = false,
  legacyResponses,
}: UseTextResponsesParams) => {
  const { data, isLoading } = useFetchTextResponses({
    adminKey,
    interactiveContentId,
    shouldFetchResults,
    sessionId,
  });

  const responses: OpenEndedResponse[] =
    shouldShowIdentifiedResponses && data?.responses
      ? data.responses.map((textResponse: TextResponse) => ({
          id: textResponse.id,
          responseText: textResponse.responseText,
          voteCount: textResponse.voteCount,
          participantDisplayName: textResponse.participant?.displayName ?? null,
        }))
      : legacyResponses.map((response) => ({
          id: response.id,
          responseText: response.answer,
          voteCount: response.upvotes,
          participantDisplayName: null,
        }));

  return {
    textResponses: data?.responses,
    responses,
    isLoading,
  };
};
